/* NAIVROX sticky add-to-cart bar */
if (!customElements.get('nvx-sticky-atc')) {
  customElements.define(
    'nvx-sticky-atc',
    class NvxStickyAtc extends HTMLElement {
      connectedCallback() {
        this.formId = this.dataset.form;
        this.form = document.getElementById(this.formId);
        this.realSubmit = this.form && this.form.querySelector('[type="submit"], .product-form__submit');
        this.btn = this.querySelector('[data-nvx-satc-add]');
        // Anchor to observe: the real buy button (or the whole product form).
        this.anchor =
          document.querySelector('.product-form__buttons') ||
          this.realSubmit ||
          this.form;

        if (!this.anchor || !this.btn) return;

        this.btn.addEventListener('click', this.onAdd.bind(this));

        this.observer = new IntersectionObserver(
          (entries) => {
            const showing = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
            this.hidden = !showing;
          },
          { rootMargin: '0px 0px 0px 0px', threshold: 0 }
        );
        this.observer.observe(this.anchor);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      onAdd() {
        // Reuse Dawn's product form so cart drawer + analytics fire normally.
        if (this.realSubmit) {
          this.realSubmit.focus({ preventScroll: true });
          this.realSubmit.click();
        } else if (this.form && this.form.requestSubmit) {
          this.form.requestSubmit();
        }
      }
    }
  );
}
